import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import useVenue from "../../hooks/useVenue";
import BoardDivider from "../BoardDivider";
import BoardItem from "../BoardItem";

import * as styles from "./styles.module.scss";

const Beer = ({ name, brewery, style, abv, last }) => {
  const { isBexley, isEltham } = useVenue();

  const hasProperties = !!(brewery || style || abv);

  return (
    <div
      className={classNames({
        [styles.bexley]: isBexley,
        [styles.eltham]: isEltham,
      })}
    >
      <div className={styles.beer}>
        <Line>
          <div className={styles.item}>
            <BoardItem text={name} />
          </div>
          <Card name={"brewery"} value={brewery} />
          <Card name={"style"} value={style} />
          <Card name={"abv"} value={abv} />
        </Line>
        {hasProperties ? (
          <Line small last={last}>
            <Card small name={"brewery"} value={brewery} />
            <Card small name={"style"} value={style} />
            <Card small name={"abv"} value={abv} />
          </Line>
        ) : (
          last && <BoardDivider />
        )}
      </div>
    </div>
  );
};

const Line = ({ last, small, children }) => (
  <>
    <BoardDivider small={small} />
    <div className={classNames(styles.line, { [styles.small]: small })}>
      {children}
    </div>
    {last && <BoardDivider />}
  </>
);

const Card = ({ name, value, small }) => {
  const className = classNames(styles.item, {
    [styles.small]: small,
    [styles.abv]: name === "abv",
    [styles.brewery]: name === "brewery",
    [styles.style]: name === "style",
  });

  const text = `${value}${name === "abv" ? "%" : ""}`;
  return (
    value && (
      <div className={className}>
        <BoardItem text={text} small style="subtle" />
      </div>
    )
  );
};

Beer.propTypes = {
  name: PropTypes.string.isRequired,
  brewery: PropTypes.string,
  style: PropTypes.string,
  abv: PropTypes.string,
  last: PropTypes.bool,
};

Line.propTypes = {
  children: PropTypes.element,
  last: PropTypes.bool,
  small: PropTypes.bool,
};

Card.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  small: PropTypes.bool,
};

export default Beer;
